export const english = {
    RESPONSE_ERROR_400:
        'An error occurred while processing your request. Please contact the administrator or try to get data again.',
    RESPONSE_ERROR_401: 'The page has expired.',
    RESPONSE_ERROR_404: 'No data have met given requirements.',
    RESPONSE_ERROR_500:
        'An error occurred while processing your request. Please contact the administrator or try to get data again.',
    RESPONSE_ERROR_503: 'Server unavailable. Try again later.',
    SLUZBA_NEDOSTUPNA: '',

    CHYBA_OBECNA: '',
    CHYBA_CHYBA: '',
    CHYBA_JINYUCET: '',
    CHYBA_NEPREDANEPARAMETRY: '',

    NACITANI: 'Loading...',
    NEVALIDNI_POVINNA_POLOZKA: '',
    NEVALIDNI_EMAIL: 'Invalid e-mail',
    NEVALIDNI_EMAIL_SHODA: '',
    NEVALIDNI_TELEFON: 'Invalid phone number',
    POKRACOVAT: 'Continue',
    PREJIT_ZPET_NA_PRIHLASENI: '',

    EMAIL: 'E-mail',
    EMAIL_CHECK: '',
    PHONE_NUMBER: 'Phone number',

    BANK_ID: 'BankID',
    VYPIS_Z_UCTU: '',

    NEZARAZENY_UCET: '',
    PODANI_NOVE_ZADOSTI_INFO_O_SLUZBE: '',

    NEZARAZENY_UCET_PRIHLASENI: '',
    PRISTUP_K_DRIVE_PODANE_ZADOSTI: '',

    PRIHLASIT_SE_PPRES_BANKID: '',
    FORMA_UHRADY: '',
    ZADOST_O_SLUZBU_K_AKTUALNIMU_DATU: '',
    ZADATEL: '',
    ZPET: 'Back',
    CELKOVA_CASTKA: '',
    ZADOST_BYLA_ODESLANA: '',
    O_ZPRACOVANI_BUDETE_INFORMOVANI: '',
    POTVRDIT_SOUHLAS: '',
    POTVRDIT_A_ODESLAT: '',
    ZAPLATIT: 'Pay',
    MOZNOST_STAHNOUT_DO: '',
    STAHNOUT: 'Download',
    VYPLNTE_CHYBEJICI_UDAJE: '',
    SHRNUTI_OBJEDNAVKY: '',

    STAV_IDEN: '',
    KROKY_PRO_ZISKANI_VYSTUPU: '',
    POTVRZENI_ZADOSTI: '',
    SOUHLAS_S_PODMINKAMI: '',
    ZAPLACENI_POPLATKU_KARTOU: '',
    POSKYTNUTI_RC: '',
    STAZENI_VYPISU_A_FAKTURY: '',
    SOUHLASIM_S: '',
    PODMINKAMI_SLUZBY: '',
    VYPIS_Z_NEZAR_UCTU_K_AKTUALNIMU_DATU: '',

    PODMINKY_SLUZBY: '',
    PODMINKY_P1: '',
    PODMINKY_P2: '',
    PODMINKY_P3: '',
    PODMINKY_P4: '',
    PODMINKY_P5: '',

    STAV_PLZRUS: '',
    STAV_PLODLO: '',
    STAV_PLZAPL: '',
    STAV_CEKA: '',
    STAV_DUPL: '',
    STAV_ZPRAC_1: '',
    STAV_ZPRAC_2: '',
    STAV_VYPR: '',
    NEZNAMY_STAV: 'Unknown state',
    DETAILLEI_LEI: 'LEI',
    DETAILLEI_LEGALNAME: 'Legal Entity Name',
    DETAILLEI_TRANSLITOTHERENTITYNAME: 'English Entity Name',
    DETAILLEI_ADDRESS: 'Registered Address',
    DETAILLEI_REGISTRATIONAUTHORITYID: 'Register',
    DETAILLEI_REGISTAUTHORITYENTITYID: 'Business Registry Identifier',
    DETAILLEI_LEGALJURISDICTION: 'Legal Jurisdiction',
    DETAILLEI_ENTITYCATEGORY: 'Category of Subject',
    DETAILLEI_LEGALFORM: 'Entity Legal Form',
    DETAILLEI_ENTITYSTATUS: 'Entity Status',
    DETAILLEI_ENTITYCREATIONDATE: 'Entity Creation Date',
    DETAILLEI_ENTITYLEGALFORMCODE: 'Entity Legal Form',
    DETAILLEI_INITIALREGISTRATIONDATE: 'Registration Date',
    DETAILLEI_LASTUPDATEDATE: 'Date of last update',
    DETAILLEI_REGISTRATIONSTATUS: 'Status LEI',
    DETAILLEI_OTHERREGISTAUTHORITYID: 'Other Registration Authority',
    DETAILLEI_OTHERLEGALFORM: 'Other Legal Form',
    DETAILLEI_NEXTRENEWALDATE: 'Next Renewal Date',
    DETAILLEI_MANAGINGLOU: 'Managing LOU',
    DETAILLEI_RELATIONSHIPTYPE: 'Relationship Type',
    DETAILLEI_ENDNODEID: 'LEI',
    DETAILLEI_RELATIONSHIPSTATUS: 'Status',
    DETAILLEI_EXCEPTIONCATEGORY: 'Category',
    DETAILLEI_EXCEPTIONREASON: 'Exception reason',
    DIRECT_ACCOUNTING_CONSOLIDATION_PARENT: 'Direct Consolidated Parent Company',
    ULTIMATE_ACCOUNTING_CONSOLIDATION_PARENT: 'Ultimate Consolidated Parent Company',
    LEI_GLEIF_STAV_LAPSED: 'Lapsed',
    LEI_GLEIF_STAV_MERGED: 'Merged',
    LEI_GLEIF_STAV_RETIRED: 'Retired',
    LEI_GLEIF_STAV_ANNULLED: 'Annulled',
    LEI_GLEIF_STAV_CANCELLED: 'Cancelled',
    LEI_GLEIF_STAV_TRANSFERRED: 'Transferred',
    LEI_GLEIF_STAV_PENDING_TRANSFER: 'Pending transfer',
    LEI_GLEIF_STAV_PENDING_ARCHIVAL: 'Pending archival',
    LEI_GLEIF_STAV_PENDING_VALIDATION: 'Pending Validation',
    LEI_GLEIF_STAV_ISSUED: 'Issued',
    LEI_STATUS_ACTIVE: 'Active',
    LEI_STATUS_INACTIVE: 'Inactive',
    LEI_DATUM_ZMENY: 'Date of last change',
    LEI_SEZNAM: 'List of Assigned LEIs',
    LEI_SEZNAM_VYBRANYCH: 'List of selected LEIs',
    POPIS_SLUZBY: 'Service description',
    HISTORIE_VYDANNYCH_LEI: 'LEIs Datasets',
    NEVALIDNI_LEI_VS: 'Invalid LEI',
    NEVALIDNI_ICO: 'Invalid IČO',
    DUVERNE_INFO_NEPOVINNE_ERR: 'At least one of the optional parameters must be filled in',
    UDAJE_DRZITEL_LEI: 'LEI Holder Details',
    REG_UDAJE_LEI: 'LEI Registration Data',
    LEI_MATKY_INFO: 'Parent Company Information',
    INFO_LEI_FOND: 'Fund Information',
    INFO_LEI_BRANCH: 'Branch Information',
    REF_DATA_LEI: 'LEI reference data',
    UDAJE_K_DATU: 'Data is valid until',
    NATURAL_PERSONS: 'Natural persons',
    NON_CONSOLIDATING: 'Non-consolidated',
    NON_PUBLIC: 'Non-public',
    NO_KNOWN_PERSON: 'Non-known person',
    LEGAL_OBSTACLES: 'Legal obstacles',
    CONSENT_NOT_OBTAINED: 'Consent is not obtained',
    BINDING_LEGAL_COMMITMENTS: 'Binding legal commitments',
    DETRIMENT_NOT_EXCLUDED: 'Detriment is not excluded',
    DISCLOSURE_DETRIMENTAL: 'Detrimental disclosure',
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    LAPSED: 'Lapsed',
    MERGED: 'Merged',
    RETIRED: 'Retired',
    ANNULLED: 'Annulled',
    CANCELLED: 'Cancelled',
    TRANSFERRED: 'Transferred',
    PENDING_TRANSFER: 'Pending transfer',
    PENDING_ARCHIVAL: 'Pending archival',
    PENDING_VALIDATION: 'Pending Validation',
    VYHLEDAT: 'Search',
    JINY_PRAVNI_KOD: 'Other Legal Form',
    SLUZBA_ODKAZ: 'Link to the service',
    IS_SUBFUND_OF: 'Umbrella Structure',
    IS_FEEDER_TO: 'Master-Feeder',
    IS_FUND_MANAGED_BY: 'Fund Management Entity',
    POPIS_SLUBY_TEXT:
        'Stránka nabízí možnost vyhledávání v seznamu subjektů, jimž Centrální depozitář dosud přidělil LEI. Vyhledávat lze podle LEI, IČ a názvu společnosti.',
    '': ''
};
